import store from "@/store";
export class FunctionSettingService {

  constructor() {
  }

  private valid() {
    const groupCd: any = window.localStorage.getItem("groupCd");
    const shatenCd: any = window.localStorage.getItem("shatenCd");
    const kyotenCd: any = window.localStorage.getItem("kyotenCd");
    const functionSetting = store.getters["FunctionSetting/currentState"];

    return ( groupCd && groupCd == functionSetting.groupCd
      && shatenCd && shatenCd == functionSetting.shatenCd
      && kyotenCd && kyotenCd == functionSetting.kyotenCd
    );
  }

  public isDebug() {
    const functionSetting = store.getters["FunctionSetting/currentState"];
    return this.valid && functionSetting && functionSetting.isDebug == "1";
  }
}